module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/hu-card-drag.59f59dc3311ae40151b5.gif";